import { get } from '@/services/http';
import { OAClientModel } from '@/models/OAClient';
import List from './list';

export class OAClientsCollection extends List<OAClientModel> {
  public async fetch() {
    const res: any = await get(`/oauth-clients`, {});
    const clients = res || [];
    this.mapData(clients);
  }

  public mapData(clients: any[]) {
    this.items = [];
    for (const c of clients) {
      const client = new OAClientModel();
      client.mapData(c);
      this.add(client);
    }
  }
} 